export enum ChannelStatus {
    PREPARING = 1,
    ON_AIR = 2,
    OFF_AIR = 3
}